import { AssetType } from "../types/AssetType";
import { DocumentReuseStatus } from "../types/Inspection";
import InspectionElement from "../types/InspectionElement";

export const showDocumentReuse = (
    assetType: AssetType,  isDocumentCollector: boolean, inspectionDocumentReuseStatus?: DocumentReuseStatus | null, elements?: InspectionElement[]) => {

    if (!isDocumentCollector) {
        return false;
    }

    if (assetType !== AssetType.Document) {
        return false;
    }

    if (inspectionDocumentReuseStatus !== DocumentReuseStatus.NOT_SELECTED) {
        return false;
    }

    if (!elements) {
        return false;
    }

    const reuseableElementsHaveDocuments = elements.some((element) => element.ReUseDocuments && element.Documents.length > 0);
    return reuseableElementsHaveDocuments;
}

export const getValidUntilDate = (reusableExpiryMetadata: string, t: any) => {
    if (!reusableExpiryMetadata || !isValidDate(reusableExpiryMetadata)) {
        return t("reuseDocuments.noExpiryDate");
    }

    const validUntilDate = new Date(+reusableExpiryMetadata);
    return validUntilDate.toLocaleDateString();
}

const isValidDate = (dateString: string) => {
    const date = new Date(+dateString);
    return date instanceof Date && !isNaN(date.getTime());
}
